/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ReimbursementType } from './ReimbursementType';
import {
    ReimbursementTypeFromJSON,
    ReimbursementTypeFromJSONTyped,
    ReimbursementTypeToJSON,
} from './ReimbursementType';

/**
 * 
 * @export
 * @interface PayerContractUpdate
 */
export interface PayerContractUpdate {
    /**
     * 
     * @type {string}
     * @memberof PayerContractUpdate
     */
    name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PayerContractUpdate
     */
    facility_ids?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PayerContractUpdate
     */
    type?: PayerContractUpdateTypeEnum;
    /**
     * 
     * @type {ReimbursementType}
     * @memberof PayerContractUpdate
     */
    reimbursement_type?: ReimbursementType;
    /**
     * 
     * @type {string}
     * @memberof PayerContractUpdate
     */
    s3_key?: string;
    /**
     * 
     * @type {string}
     * @memberof PayerContractUpdate
     */
    expiry_date?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PayerContractUpdate
     */
    processing_status?: PayerContractUpdateProcessingStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PayerContractUpdate
     */
    processing_error?: PayerContractUpdateProcessingErrorEnum;
}


/**
 * @export
 */
export const PayerContractUpdateTypeEnum = {
    Commercial: 'Commercial',
    ManagedMedicare: 'Managed Medicare',
    ManagedMedicaid: 'Managed Medicaid',
    Medicare: 'Medicare',
    Medicaid: 'Medicaid',
    Other: 'Other',
    PrivatePay: 'Private Pay'
} as const;
export type PayerContractUpdateTypeEnum = typeof PayerContractUpdateTypeEnum[keyof typeof PayerContractUpdateTypeEnum];

/**
 * @export
 */
export const PayerContractUpdateProcessingStatusEnum = {
    Created: 'created',
    InProgress: 'in_progress',
    Completed: 'completed',
    Error: 'error'
} as const;
export type PayerContractUpdateProcessingStatusEnum = typeof PayerContractUpdateProcessingStatusEnum[keyof typeof PayerContractUpdateProcessingStatusEnum];

/**
 * @export
 */
export const PayerContractUpdateProcessingErrorEnum = {
    Error: 'error',
    InsufficientInfo: 'insufficient_info',
    WrongPayer: 'wrong_payer'
} as const;
export type PayerContractUpdateProcessingErrorEnum = typeof PayerContractUpdateProcessingErrorEnum[keyof typeof PayerContractUpdateProcessingErrorEnum];


/**
 * Check if a given object implements the PayerContractUpdate interface.
 */
export function instanceOfPayerContractUpdate(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PayerContractUpdateFromJSON(json: any): PayerContractUpdate {
    return PayerContractUpdateFromJSONTyped(json, false);
}

export function PayerContractUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): PayerContractUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'facility_ids': !exists(json, 'facility_ids') ? undefined : json['facility_ids'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'reimbursement_type': !exists(json, 'reimbursement_type') ? undefined : ReimbursementTypeFromJSON(json['reimbursement_type']),
        's3_key': !exists(json, 's3_key') ? undefined : json['s3_key'],
        'expiry_date': json['expiry_date'] === null ? null : !exists(json, 'expiry_date') ? undefined : json['expiry_date'],
        'processing_status': !exists(json, 'processing_status') ? undefined : json['processing_status'],
        'processing_error': !exists(json, 'processing_error') ? undefined : json['processing_error'],
    };
}

export function PayerContractUpdateToJSON(value?: PayerContractUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'facility_ids': value.facility_ids,
        'type': value.type,
        'reimbursement_type': ReimbursementTypeToJSON(value.reimbursement_type),
        's3_key': value.s3_key,
        'expiry_date': value.expiry_date,
        'processing_status': value.processing_status,
        'processing_error': value.processing_error,
    };
}
